import { LicenseInfo } from '@mui/x-license';
LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_PREMIUM_LICENSE_KEY);

import React from 'react';
window.React = React; // Ensure React is available globally
import { createRoot } from 'react-dom/client';

// style.scss
import 'assets/style.css';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// apex-chart
import 'assets/third-party/apex-chart.css';

// mapbox
import 'mapbox-gl/dist/mapbox-gl.css';

// google-fonts
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/700.css';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';

import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
import '@fontsource/poppins/600.css';
import '@fontsource/poppins/700.css';
import '@fontsource/poppins/800.css';

import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';

// project imports
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ConfigProvider } from 'contexts/ConfigContext';

const container = document.getElementById('root');
const root = createRoot(container!);

// Handle dynamic import errors (e.g., after new deployment)
const handleDynamicImportError = (error: any) => {
  const errorString = error?.toString() || '';
  const errorMessage = error?.message || (typeof error === 'string' ? error : '');

  const isDynamicImportError =
    /Failed to fetch dynamically imported module/i.test(errorMessage) ||
    /Failed to fetch dynamically imported module/i.test(errorString) ||
    /Importing a module script failed/i.test(errorMessage) ||
    /Importing a module script failed/i.test(errorString) ||
    /error loading dynamically imported module/i.test(errorMessage) ||
    /error loading dynamically imported module/i.test(errorString);

  if (isDynamicImportError) {
    if (!sessionStorage.getItem('retry-lazy-refreshed')) {
      sessionStorage.setItem('retry-lazy-refreshed', 'true');
      window.location.reload();
    }
  }
};

window.addEventListener('unhandledrejection', (event) => {
  handleDynamicImportError(event.reason);
});

window.addEventListener('error', (event) => {
  handleDynamicImportError(event.error || event.message);
});

// Clear the flag on successful load
window.addEventListener('load', () => {
  sessionStorage.removeItem('retry-lazy-refreshed');
});


// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <ConfigProvider>
    <App />
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
